/**
 * The road landing, drawn by index.html before any bundle has loaded, for an
 * ad visitor in the `landing` experiment's `road` arm (lib/experiments.ts).
 *
 * The markup is FirstRoad's own (components/FirstRoad.tsx with the ad's
 * promise, as a new visitor sees it), kept in index.html as a <template> and
 * held to the component by data/road-predraw.test.ts, so nothing moves when
 * the app takes over. A tap on its button before then is kept here, and the
 * app acts on it the moment it arrives, as lib/pre-quiz.ts does for the
 * question.
 */
export interface PreRoad {
  /** the door the ad named, for the promise line */
  slug: string;
  /** the whole drawn screen, #road-pre */
  el: HTMLElement;
  /** its button was tapped before the app was here */
  went: boolean;
  /** performance.now() when it was drawn, and of the tap */
  drawnAt: number;
  wentAt: number | null;
  claimed?: boolean;
}

declare global {
  interface Window { __kindlingPreRoad?: PreRoad }
}

/** The drawn road, for the landing screen to take over. */
export function claimPreRoad(): PreRoad | null {
  if (typeof window === 'undefined') return null;
  const pre = window.__kindlingPreRoad;
  if (!pre) return null;
  pre.claimed = true; // StrictMode asks twice: the same one both times
  return pre;
}

/** Once the landing is on the page: the drawn one goes. */
export function finishPreRoad(pre: PreRoad): void {
  pre.el.remove();
  if (window.__kindlingPreRoad === pre) window.__kindlingPreRoad = undefined;
}

/** Take the drawn road away when the app opens on something else. */
export function dropPreRoad(): void {
  if (typeof window === 'undefined') return;
  const pre = window.__kindlingPreRoad;
  if (!pre || pre.claimed) return;
  pre.el.remove();
  window.__kindlingPreRoad = undefined;
}
